import { DataModel } from '#data-models.ts';

import * as viewsObject from '#schema/generated/views.ts';

// biome-ignore lint/suspicious/noExplicitAny: quick fix
const filteredViews = Object.entries(viewsObject as Record<string, any>).filter(([_key, value]) =>
  [DataModel.IpsoFieldWellSurveillanceAgent.externalId].includes(value.dataModel.externalId),
);

export const views = Object.fromEntries(filteredViews) as typeof viewsObject;
